import { render, staticRenderFns } from "./ReportListV2.vue?vue&type=template&id=1937a656"
import script from "./ReportListV2.vue?vue&type=script&lang=js"
export * from "./ReportListV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports